<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import { docContent } from "@/data/TemplateSuratPermintaanKonsultasi.js";
import { headerImage } from "@/data/headerImage.js";
import { labelValueFormatter } from "@/data/helper.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocSuratPermintaanKonsultasi",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Surat Permintaan Konsultasi",
      src: "",
      content: [],
      ralan: {},
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    // getFullAddress: async function (
    //   strAddr,
    //   id_prov,
    //   id_kota,
    //   id_kecamatan,
    //   id_kelurahan
    // ) {
    //   let prov = id_prov ? await this.getRegionName("provinsi", id_prov) : "";
    //   let kota = id_kota ? await this.getRegionName("kota", id_kota) : "";
    //   let kec = id_kecamatan
    //     ? await this.getRegionName("kecamatan", id_kecamatan)
    //     : "";
    //   let kel = id_kelurahan
    //     ? await this.getRegionName("kelurahan", id_kelurahan)
    //     : "";
    //   return `${strAddr || ""}${strAddr && kel ? ", " : ""}${
    //     kel ? `${kel}` : ``
    //   }${(strAddr || kel) && kec ? ", " : ""}${kec ? `KEC. ${kec}` : ``}${
    //     (strAddr || kel || kec) && kota ? ", " : ""
    //   }${kota ? `${kota}` : ``}${
    //     (strAddr || kel || kec || kota) && prov ? ", " : ""
    //   }${prov ? `PROVINSI ${prov}` : ``}`;
    // },
    // getRegionName: async function (table, id) {
    //   try {
    //     let result = await this.$store.state.HTTP.get(`wilayah/${table}/${id}`);
    //     if (result.status == "200" && result.data) {
    //       //console.log(result);
    //       return result.data.nama;
    //     } else {
    //       return "";
    //     }
    //   } catch (e) {
    //     return "";
    //   }
    // },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },

  mounted: async function() {
    this.ralan = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    this.content = docContent;
    var draft = {
      title: "SURAT PERMINTAAN KONSULTASI",
      subtitle: "No. : _________________/20__",
      intro: `Kepada Yth:
      Dr Spesialisasi :`,
      p1: `Dengan Hormat,
    Mohon bantuan teman sejawat atas pasien:`,
      arr1: [
        { label: "Nama Pasien", value: this.ralan.pasien.nama },
        { label: "No. RM", value: this.ralan.pasien.no_rm },
        { label: "Umur", value: this.ralan.pasien.formatted_umur },
      ],
      p2: `Untuk diberikan pelayanan Konsultasi / perawatan medis bersama untuk selanjutnya / Pengambil alih kasus untuk selanjutnya disertai dengan hasil pemeriksaan berikut ini`,
      arr2: [
        {
          label: "Diagnosa",
          value: `Dx Utama:
        ${
          this.ralan.rln_periksa_dok ? this.ralan.rln_periksa_dok.dx_utama : "-"
        }
        Dx Sekunder:
        ${
          this.ralan.rln_periksa_dok
            ? this.ralan.rln_periksa_dok.dx_sekunder
            : "-"
        }
        Klasifikasi Medis:
        ${
          this.ralan.rln_periksa_dok
            ? this.ralan.rln_periksa_dok.rln_periksa_dok_penyakit
                .map((item) => {
                  return (
                    item.penyakit.tipe +
                    ` ` +
                    item.penyakit.kode +
                    ` - ` +
                    item.penyakit.desc_short
                  );
                })
                .join(",")
            : "-"
        }`,
        },
      ],
      p3: `Terimakasih atas perhatiannya.`,
    };
    var sign = `Pekanbaru, ________________________

      Dokter pemeriksa




      ( ${this.ralan.dokter.nama} )`;
    let arr1 = labelValueFormatter(draft.arr1, 200);
    let arr2 = labelValueFormatter(draft.arr2, 200);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "title",
      },
      {
        text: draft.subtitle,
        style: "subtitle",
      },
      {
        style: "paragraph",
        text: draft.intro,
      },
      {
        style: "paragraph",
        text: draft.p1,
      },
      ...arr1,
      {
        style: "paragraph",
        text: draft.p2,
      },
      ...arr2,
      {
        style: "paragraph",
        text: draft.p3,
      },
      {
        columns: [
          { text: "" },
          {
            style: "sign",
            text: sign,
          },
        ],
      },
    ];
  },
};
</script>
